module.exports = __webpack_public_path__ + "34736292/img/share-action-icon.9c12578c.svg";